module.exports = __webpack_public_path__ + "img/iconfont.7a876a7c.svg";